import { GroupDetailsDto } from '@/Models/groupManagement/groupDetailsDto';
import { GroupMemberDto } from '@/Models/groupManagement/groupMemberDto';
import { GroupCreateDto } from '@/Models/groupManagement/groupCreateDto';
import { GroupDto } from '@/Models/groupManagement/groupDto';
import DualListBoxItem from '@/VueComponents/DualListBox/types/DualListBoxItem';
import { GroupUpdateDto } from '@/Models/groupManagement/groupUpdateDto';
import apiClient from '@/Services/Clients/apiClient';
import { GroupSummaryDto } from '@/Models/groupManagement/groupSummaryDto';

const GROUPS_BASE_URL: string = 'api/groups';
class GroupsService {

  public static getAllGroups = (businessId: string): Promise<GroupSummaryDto[]> => {
    return apiClient.get(`${GROUPS_BASE_URL}/${businessId}`)
      .then((serverGroups: any) => {

        return serverGroups.map((g: any) => {
          const groupDetails = new GroupDetailsDto(g.name, g.address, g.isLocationAssigned, g.coordinate);
          const groupMembers: GroupMemberDto[] = g.groupMembers.map((gm: any) => {
            return new GroupMemberDto(
              gm.memberPersona.personaId,
              gm.memberPersona.personaDisplayName,
              gm.isGroupPrimaryContact);
          });
          return new GroupSummaryDto(g.groupId, groupDetails, groupMembers);
        });

      });
  };

  public static getAllGroupNames = (businessId: string): Promise<any> =>
    apiClient.get(`${GROUPS_BASE_URL}/${businessId}/groupNames`);

  public static addNewGroup = (businessId: string, group: any, assignedItems: DualListBoxItem[]): Promise<boolean> => {
    const groupCreateDto: GroupCreateDto = GroupsService.mapToGroupCreateDto(businessId, group, assignedItems);
    return apiClient.post(`${GROUPS_BASE_URL}`, groupCreateDto);
  };

  public static updateGroup = (groupId: string, businessId: string, group: any, assignedItems: DualListBoxItem[]): Promise<GroupDto> => {
    const groupUpdateDto: GroupUpdateDto = GroupsService.mapToGroupUpdateDto(groupId, businessId, group, assignedItems);
    return apiClient.put(`${GROUPS_BASE_URL}/${businessId}/${groupId}`, groupUpdateDto);
  };

  public static getGroupDetails = (businessId: string, groupId: string): Promise<GroupDto> =>
    apiClient.get(`${GROUPS_BASE_URL}/${businessId}/${groupId}`);

  public static deleteGroup = (businessId: string, groupId: string): Promise<any> =>
    apiClient.delete(`${GROUPS_BASE_URL}/${businessId}/${groupId}`);

  private static mapToGroupUpdateDto = (groupId: string, businessId: string, group: any, assignedItems: DualListBoxItem[]): GroupUpdateDto => {
    const groupDetails = new GroupDetailsDto(group.groupName, group.address, group.isLocationAssigned, group.coordinate);
    const assignedGroupMembers = assignedItems
      .map((item: DualListBoxItem) => {
        return new GroupMemberDto(item.id, item.name, item.isChecked);
      });
    return new GroupUpdateDto(groupId, businessId, groupDetails, assignedGroupMembers);
  };
  private static mapToGroupCreateDto = (businessId: string, group: any, assignedItems: DualListBoxItem[]): GroupCreateDto => {
    const groupDetails = new GroupDetailsDto(group.groupName, group.address, group.isLocationAssigned, group.coordinate);
    const assignedGroupMembers = assignedItems
      .map((item: DualListBoxItem) => {
        return new GroupMemberDto(item.id, item.name, item.isChecked);
      });
    return new GroupCreateDto(businessId, groupDetails, assignedGroupMembers);
  };
}
export default GroupsService;
